/**
 * Shared BorderBeam / Effort max-gradient colors (composer opaque well + DiscreteScaleField).
 * Sole hex SoT for landing-beam chrome — do not duplicate these literals at call sites.
 */
export const LANDING_BEAM_FROM = "#ffaa40";
export const LANDING_BEAM_TO = "#9c40ff";
